<template>
    <div class="soli-round">
        <v-dialog
            v-model="dialog"
            :fullscreen="$vuetify.breakpoint.xs ? true : false"
            :content-class="$vuetify.breakpoint.xs ? '' : 'soli-round'"
            :transition="
                $vuetify.breakpoint.smAndDown
                    ? 'dialog-bottom-transition'
                    : 'dialog-transition'
            "
            max-width="600px"
            @click:outside="[(dialog = false), $emit('reset')]"
        >
            <v-card>
                <v-btn
                    icon
                    @click="[(dialog = false), $emit('reset')]"
                    class="ma-3 soli-close soli-grey soli-text-shadow"
                    ><v-icon>clear</v-icon></v-btn
                >
                <v-card-title>Quick Links</v-card-title>
                <v-card-subtitle>Helpful resources</v-card-subtitle>
                <v-container class="pt-0">
                    <v-list
                        dense
                        v-for="(title, idx) in Object.keys(linksList)"
                        :key="idx"
                    >
                        <div class="text-subtitle-2 soli-grey px-4">
                            {{ title }}:
                        </div>
                        <div
                            class="text-subtitle-1 px-4"
                            v-for="item in linksList[title]"
                            :key="item.title"
                        >
                            <a :href="item.url" target="_blank">{{
                                item.title
                            }}</a>
                        </div>
                    </v-list>
                </v-container></v-card
            ></v-dialog
        >
    </div>
</template>

<script>
export default {
    name: "QuickLinks",
    data() {
        return {
            dialog: true,
            linksList: {
                "For Teachers": [
                    {
                        title: "All Teacher Training and Help Content",
                        url: "https://support.musicologie.com/",
                    },
                    {
                        title: "New Teacher Training",
                        url: "https://support.musicologie.com/courses/teacher-training/",
                    },
                    {
                        title: "Guide for Teaching Ages 4-7",
                        url: "https://support.musicologie.com/courses/guide-for-teaching-ages-4-7/",
                    },
                    {
                        title: "Musicologie Junior Training",
                        url: "https://support.musicologie.com/courses/musicologie-junior-training/",
                    },
                    {
                        title: "Accelerated Piano Lab Training",
                        url: "https://support.musicologie.com/courses/accelerated-piano-lab/",
                    },
                    {
                        title: "Apply for Teacher Certification",
                        url: "https://support.musicologie.com/courses/musicologie-teacher-certification/",
                    },
                    {
                        title: "DEI Resources",
                        url: "https://support.musicologie.com/courses/dei-resources/",
                    },
                ],
                "For Community Managers": [
                    {
                        title: "All CM Training and Help Articles",
                        url: "https://cm.musicologielessons.com/",
                    },
                    {
                        title: "Musicologie Software Training",
                        url: "https://support.musicologie.com/lessons/the-musicologie-software/",
                    },
                    {
                        title: "New Teacher Onboarding Checklist",
                        url: "https://cm.musicologielessons.com/knowledge-base/new-teacher-onboarding-checklist/",
                    },
                    {
                        title: "Teacher Interview Questions",
                        url: "https://docs.google.com/forms/d/1V3bYCGEbwxA5mg9ji1N5y-WFxySJPPLdB6JdRwwnD4E/viewform?edit_requested=true",
                    },
                    {
                        title: "Musicologie Brand Portal",
                        url: "https://musicologie.s4mrc.com/",
                    },
                    {
                        title: "Emma Email Marketing",
                        url: "https://app.e2ma.net/app2/login/",
                    },
                ],
                "For Students": [
                    {
                        title: "Student Help Site",
                        url: "https://musicologie.com/help",
                    },
                    {
                        title: "Login",
                        url: "https://musicologie.com/login",
                    },
                    {
                        title: "How to Cancel and Reschedule",
                        url: "https://help.musicologielessons.com/how-to-cancel-and-reschedule/",
                    },
                    {
                        title: "Policies",
                        url: "https://help.musicologielessons.com/category/policies/",
                    },
                    {
                        title: "Leave a Review",
                        url: "https://musicologie.com/review",
                    },
                ],
            },
        };
    },
};
</script>
